var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from "react";
import { autorun } from "mobx";
import { observer } from "mobx-react";
import { ComponentFactory } from "./ComponentFactory";
import { getStyles } from "./HSplit.styles";
import { getClassNames } from "./HSplit.classNames";
import { css } from "@uifabric/utilities";
var HSplit = /** @class */ (function (_super) {
    __extends(HSplit, _super);
    function HSplit() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onDocumentMouseUp = function (e) {
            _this._ref.ownerDocument.removeEventListener("mousemove", _this._onDocumentMouseMove);
            _this._ref.ownerDocument.removeEventListener("mouseup", _this._onDocumentMouseUp);
            _this.props.hsplit.setSplitActive(false);
        };
        _this._onDocumentMouseMove = function (e) {
            e.preventDefault();
            _this._resize(e);
        };
        _this._onSplitterMouseDown = function (e) {
            e.preventDefault();
            _this._ref.ownerDocument.addEventListener("mousemove", _this._onDocumentMouseMove);
            _this._ref.ownerDocument.addEventListener("mouseup", _this._onDocumentMouseUp);
            _this.props.hsplit.setSplitActive(true);
        };
        _this._onRef = function (ref) {
            _this._ref = ref;
        };
        _this._onSplitterRef = function (ref) {
            _this._splitterRef = ref;
        };
        _this._onLeftPaneRef = function (ref) {
            _this._leftPaneRef = ref;
        };
        _this._onRightPaneRef = function (ref) {
            _this._rightPaneRef = ref;
        };
        _this._onResize = function () {
            var bounds = _this._ref.getBoundingClientRect();
            var splitterBounds = _this._splitterRef.getBoundingClientRect();
            var leftWidth = Math.floor(bounds.width * _this.props.hsplit.offset);
            var rightWidth = bounds.width - leftWidth - splitterBounds.width;
            _this._leftPaneRef.style.width = leftWidth + "px";
            _this._splitterRef.style.left = _this._leftPaneRef.style.width;
            _this._rightPaneRef.style.width = rightWidth + "px";
            if (_this.props.hsplit.left) {
                _this.props.hsplit.left.emit({ type: "resize" });
            }
            if (_this.props.hsplit.right) {
                _this.props.hsplit.right.emit({ type: "resize" });
            }
        };
        return _this;
    }
    HSplit.prototype._resize = function (e) {
        var minItemWidth = this.props.hsplit.minItemWidth;
        var bounds = this._ref.getBoundingClientRect();
        var splitterBounds = this._splitterRef.getBoundingClientRect();
        var max = bounds.width - splitterBounds.width - minItemWidth;
        var splitterPos = e.clientX - bounds.left;
        if (splitterPos <= minItemWidth) {
            splitterPos = minItemWidth;
        }
        else if (splitterPos >= max) {
            splitterPos = max;
        }
        var offset = splitterPos / bounds.width;
        this.props.hsplit.setOffset(offset);
    };
    HSplit.prototype.componentDidMount = function () {
        this._offsetReactionDisposer = autorun(this._onResize);
        this.props.hsplit.addEventListener("resize", this._onResize);
    };
    HSplit.prototype.componentWillUnmount = function () {
        if (this._offsetReactionDisposer) {
            this._offsetReactionDisposer();
            delete this._offsetReactionDisposer;
        }
        this.props.hsplit.removeEventListener("resize", this._onResize);
    };
    HSplit.prototype.render = function () {
        var classNames = getClassNames(getStyles(null, this.props.styles), this.props.className);
        var left = this.props.hsplit.left;
        var right = this.props.hsplit.right;
        var leftContent = ComponentFactory(left);
        var rightContent = ComponentFactory(right);
        return (React.createElement("div", { className: classNames.root, ref: this._onRef },
            React.createElement("div", { className: classNames.leftPane, ref: this._onLeftPaneRef, style: { width: "50%" } },
                React.createElement("div", { className: classNames.leftContent }, leftContent)),
            React.createElement("div", { className: css(classNames.splitter, { active: this.props.hsplit.splitActive }), onMouseDown: this._onSplitterMouseDown, ref: this._onSplitterRef },
                React.createElement("div", { className: css(classNames.splitterContent, { active: this.props.hsplit.splitActive }) })),
            React.createElement("div", { className: classNames.rightPane, ref: this._onRightPaneRef, style: { width: "50%" } },
                React.createElement("div", { className: classNames.rightContent }, rightContent))));
    };
    HSplit = __decorate([
        observer
    ], HSplit);
    return HSplit;
}(React.Component));
export { HSplit };
